import { createSlice } from "@reduxjs/toolkit";
import { GET_BY_ID_REPORT_USERS_ACTION, GET_REPORT_USERS_ACTION } from "./ReportSlice.action";
const ReportSlice = createSlice({
    name: "reportSlice",
    initialState: {
        loading: false,
        error: null,
        report: [],
        reportDetails: []
    },
    extraReducers: (builder) => {
        builder
            .addCase(GET_REPORT_USERS_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_REPORT_USERS_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.report = action.payload;
            })
            .addCase(GET_REPORT_USERS_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(GET_BY_ID_REPORT_USERS_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_BY_ID_REPORT_USERS_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.reportDetails = action.payload;
            })
            .addCase(GET_BY_ID_REPORT_USERS_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
})
export default ReportSlice;